import { jsxs as c, jsx as r } from "react/jsx-runtime";
import { FacebookIcon as t } from "../../../assets/svgs/FacebookIcon.js";
import { InstagramIcon as i } from "../../../assets/svgs/InstagramIcon.js";
const s = ({
  socialMediaLinks: o,
  sendEvent: e
}) => {
  if (!o)
    return null;
  const { facebook: n, instagram: a } = o;
  return /* @__PURE__ */ c("div", { className: "social-media-container", children: [
    n && /* @__PURE__ */ r(
      "a",
      {
        href: n,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: () => e("facebook"),
        children: /* @__PURE__ */ r(t, {})
      }
    ),
    a && /* @__PURE__ */ r(
      "a",
      {
        href: a,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: () => e("instagram"),
        children: /* @__PURE__ */ r(i, {})
      }
    )
  ] });
};
export {
  s as SocialMedia
};
